import {
    createSelectors, createStoreWithImmerAndLogger,
} from "./base";
import { request } from "../utils/useRequest";
import _ from "lodash";

const initState = {
    cached: {},
    status: {},
};

// const createStore = createStoreWithName('jymt-common-storage');
const createStore = createStoreWithImmerAndLogger;

export const cacheBaseStore =
    createStore(
        (set, get) => ({
            ...initState,

            getOr:(key, orData) => {
                const data = get().cached[key];
                if (data) return data;
                set(state => {
                    state.cached[key] = orData;
                });
            },
            get: (key) => {
                return get().cached[key];
            },
            set: (key, data) => {
                set(state => {
                   state.cached[key] = data;
                });
            },
            getOrFn: async (key, fn) => {
                const data = get().cached[key];
                // 1 找到直接返回
                if (!!data) {
                    console.log('【cached】=> get data in CACHE', data);
                    return Promise.resolve(data);
                }
                // 2 没找到：看看在不在加载中
                const loading = get().status[key];
                // 2.1 如果加载中，则等待加载完成，这里返回的是一个Promise
                if (loading) {
                    console.log(`【cached】=> loading in CACHE...${key}`);
                    return loading;
                }
                // 2.2 没有加载中，则去加载（只会执行一次）
                console.log('【cached】=> start loading in CACHE...');
                // 3 加载之
                const loadingResult =
                    Promise
                        .resolve(fn())
                        .then(result => {
                            // console.log(`【cached】=> end of loading in CACHE...${key}`, result);
                            // 改状态
                            set(state => {
                                state.cached[key] = result;
                                state.status[key] = false;
                            });
                            return result;
                        });

                // 第一次加载：设置状态为加载中的Promise，供其他使用
                set(state => {
                    state.status[key] = loadingResult;
                });
                // 4 返回加载的结果
                return loadingResult;
            }
        })
    ) // create
;

export const useCacheStore = createSelectors(cacheBaseStore);
